import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const StoreCode = ({ codeType }) => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const code = params.get(codeType);

        if (code) {
            localStorage.setItem(codeType, code);
        }

        navigate('/signup');
    }, [location, navigate, codeType]);

    return null;
};

export default StoreCode;
